import Vue from "vue";
import _ from "lodash";
const ip = Vue.prototype.$gykj_ws;
const suffix = Vue.prototype.$gykj_ws_suffix;
const socket = Vue.prototype.$gykj_ws_list;


export default class OSWebsocket {
    public $ws?: any;
    public lockReturn?: boolean = false;
    public timeout?: any = 1000 * 5;
    public timeoutObj?: any;
    public timeoutNum?: any;
    public serverTimeoutObj?: any;
    public randomNumber?: any;
    public configServiceName?: any;

    constructor(config: any,order: any) {
        this.configServiceName = config;
        if(typeof order ==="undefined" || order===""){
            this.randomNumber = String(_.random(5,true)).substring(2);
        }else {
            this.randomNumber = order;
        }
        this.wsError = this.wsError.bind(this);
        this.wsOpen = this.wsOpen.bind(this);
        this.wsMsg = this.wsMsg.bind(this);
        this.initWebSocket(this.configServiceName,this.randomNumber)
    }

    /**
     * 初始化websocket
     * @param configServiceName  服务名
     * @param randomNumber    服务名随机数【对应不同页面或者对应不同websocket连接】
     */
    public initWebSocket(configServiceNameArg,randomNumber) {
        const serviceName = configServiceNameArg;
        const url = ip+configServiceNameArg+suffix+randomNumber;
        this.$ws = new WebSocket(url);// 写入地址 这里的地址可以在initWebSocket方法加入参数
        this.$ws.onopen = this.wsOpen;
        this.$ws.onclose = this.wsClose;
        // this.$ws.onmessage = this.wsMsg;
        this.$ws.onerror = this.wsError;
        if (socket[serviceName] instanceof Array) {
            socket[serviceName].push(this.$ws);
        } else {
            const arraySocket = [];
            arraySocket.push(this.$ws)
            socket[serviceName] = arraySocket;
        }

    }

    // 开启websocket
    public wsOpen(e: any) {
        console.log("WebSocket打开连接成功:");
        console.log(this.configServiceName);
    }

    // 关闭websocket
    public wsClose(e: any) {
        // this.startWsHeartbeat();
        for(const item in socket){
            const that_ws = socket[item];
            that_ws.forEach((temp,index)=>{
                if(temp.readyState === 3){
                    console.log("websocket服务 关闭了........");
                    console.log(item)
                    that_ws.splice(index,1);
                }
            })
        }
        console.log(socket)
    }

    // 关闭websocket
    public wsMsg(msg: any) {
        console.log(msg, '封装组件msg');
    }

    // 异常处理
    public wsError(err: any) {
        console.log(err, 'ws error');
    }

    // 开始心跳监测
    public startWsHeartbeat() {
        const _this = this;
        let increNm = 0;
        if (_this.timeoutObj) clearTimeout(_this.timeoutObj);
        if (_this.serverTimeoutObj) clearTimeout(_this.serverTimeoutObj);
        _this.timeoutObj = setInterval(function () {
            console.log("检测心跳......")
            console.log(_this.$ws.readyState)
            // 判断websocket当前状态
            if (_this.$ws.readyState !== 1) {
                _this.reconnect()
            }
        if(increNm>5){
            _this.closeHeartbeat();
        }
            increNm+=increNm;
        console.log(increNm);
        }, 10000);
    }

    // 重启
    // private reconnect() {
    //     const _this = this;
    //     if (_this.lockReturn) {
    //         return;
    //     }
    //     _this.lockReturn = true;
    //     if (_this.timeoutNum) clearTimeout(_this.timeoutNum);
    //     _this.timeoutNum = setTimeout(function () {
    //         _this.initWebSocket(_this.configServiceName,_this.randomNumber);
    //         if (_this.$ws.readyState !== 1) {
    //             _this.lockReturn = false;
    //         }
    //     }, 1000);
    // }



    private reconnect() {
        const _this = this;
        if (_this.lockReturn) {
            return;
        }
        _this.lockReturn = true;
        console.log("_this.lockReturn")
        console.log(_this.lockReturn);
        if (_this.timeoutNum) clearTimeout(_this.timeoutNum);
        console.log(_this.configServiceName)
        this.randomNumber = String(_.random(5,true)).substring(2);
        console.log(_this.randomNumber)
        _this.initWebSocket(_this.configServiceName,_this.randomNumber);
        if (_this.$ws.readyState !== 1) {
            _this.lockReturn = false;
        }
    }

    // 重置websocket心跳
    public resetHeartbeat() {
        const _this = this;
        clearTimeout(_this.timeoutObj);
        clearTimeout(_this.serverTimeoutObj);
        // _this.startWsHeartbeat();
    }

    public closeHeartbeat() {
        const _this = this;
        clearTimeout(_this.timeoutObj);
        clearTimeout(_this.serverTimeoutObj);
    }

    // 发送消息
    public sendMessage(data: any) {
        if (this.$ws.readyState === this.$ws.OPEN) {
            this.$ws.send(JSON.stringify(data))
        } else {
            setTimeout(() => {
                this.sendMessage(data);
            })
        }
    }
}

